angular
	.module('overlayModal.components', [])
	.component('overlayModal', {
		templateUrl: 'ng/components/overlayModal/overlayModal.html',
		bindings: {
			//text: '=',
			//nameclass: '='
		},
		controllerAs: 'overlayModalCtrl',
		controller: function ($rootScope, $timeout) {

			//Not to loose the *this reference
			var self = this;

			self.getMessages = function () {
				var currentLanguage = $rootScope.selectedLanguage;
				self.lang = structuredClone(langItems.filter(function (map) {
					return map.code == currentLanguage;
				}).map(function (value) {
					return value.map
				})[0]);
			}

			/**
			 * Init bindings here
			 */
			self.$onInit = function () {
				/** Extract the map of the current language **/
				self.getMessages();
				/** Show the right message **/
				//self.currentMessage = self.lang[self.text].msg;
				//self.nameclass = self.pickColor(self.lang[self.text].color);
			}

			self.alertsList = [];

			$rootScope.$on('addAlert', function (event, alert) {
				var langBackup = structuredClone(self.lang)
				self.getMessages();
				var tempOfCloseModal = 30000;
				if (alert.text == "ERROR_WF_FUNCTIONAL") {
					self.errorIsWF = true;
				} else {
					self.errorIsWF = false;
				}
				delete self.lang["ERROR_WF_FUNCTIONAL"];
				self.lang["UPLOAD_OVERRUN"] && delete self.lang["UPLOAD_OVERRUN"];
				if (!self.lang[alert.text]) {
					if (alert.text == 'ERROR_PRINT_TIMEOUT') {
						Object.assign(self.lang, {
							[alert.text]: {
								"msg": alert.message,
								"color": "#FFAA00"
							}
						});

					} else {
						Object.assign(self.lang, {
							[alert.text]: {
								"msg": alert.message,
								"color": "#FF0000"
							}
						});

					}

				}
				if (alert.text == "DOCUMENT_NOT_CONGRUENT_WITH_NSIL") {
					self.lang[alert.text].msg = alert.message
				}
				if (self.lang[alert.text].color && self.lang[alert.text].color.substring(0, 3).replace('#', '') === 'FF') {
					tempOfCloseModal = 60000;
				} else {
					tempOfCloseModal = 30000;
				}
				alert.dynamicInput && alert.dynamicInput.forEach(element => {
					self.lang[alert.text].msg = self.lang[alert.text].msg.replace(/{(?<=\{)(.*?)(?=\})}/, element)
				});
				if (alert && alert.text && !alert.id) {
					if (alert.otherText) {
						self.otherText = ', sostituito con :' + alert.otherText;
					} else {
						self.otherText = "";
					}
					alert.id = new Date().getTime();
					var sameAlert = self.alertsList.find(function (el) {
						return el.text == alert.text;
					});
					var sameAlertIndex = self.alertsList.findIndex(function (el) {
						return el.text == alert.text;
					});

					if (sameAlert) { // && $('#alert-'+sameAlert.id).length
						self.alertsList.splice(sameAlertIndex, 1);
					} else {
						self.alertsList.forEach(a => self.lang[a.text].msg = langBackup[a.text].msg)
					}

					self.alertsList.unshift(alert);
					if (self.alertsList.length >= 5) {
						self.alertsList.pop();
					}

					$timeout(function () {
						var alertIndex = self.alertsList.findIndex(function (el) {
							return el.id == alert.id;
						});
						if (alertIndex != -1 && $('#alert-' + alert.id).length) {
							self.alertsList.splice(alertIndex, 1);

						}
					}, tempOfCloseModal);
				}
			});

			self.removeAlert = function (id) {
				var alertIndex = self.alertsList.findIndex(function (el) {
					return el.id == id;
				});
				if (alertIndex != -1) {
					self.alertsList.splice(alertIndex, 1);
				}
			}


			self.pickColor = function (color) {
				if (color == '#FF0000') {
					return 'alert-overlay-error';
				} else if (color == '#FFAA00') {
					return 'alert-overlay-warning';
				} else {
					return 'alert-overlay-success'
				}
			}

			self.closeOverlayAlert = function () {
				$rootScope.showMessage = false;
			}

			self.getMessage = function () {

			}



		}
	});